export const blackColor = '#24292C';
export const secondaryBlackColor = '#2B3033';
export const darkGreyColor = '#454A4B';
export const greyColor = '#939696';
export const whiteColor = '#F7F7F7';
export const primaryColor = '#FF8282';
export const secondaryColor = '#dabc75';